import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { PositionNotFountError } from "../../domain/errors/position-not-found-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Position } from "../../domain/models/position-model";
import { LoadPositionByEan } from "../../domain/usecases/load-position-by-ean";

import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadPositionByEan implements LoadPositionByEan {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(codes: string[], warehouseId: number): Promise<Position[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { codes, warehouseId },
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.noContent:
        throw new PositionNotFountError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
